import {
    createArrayField,
    createObjectField,
    createPrimitiveField,
    type InferFieldValue,
} from '@adv-frontend/form-kit';
import { intervalField, type IntervalFieldValue } from './intervalField';

export const arrayIntervalField = createArrayField({
    field: () =>
        createObjectField({
            fields: {
                intervalField: intervalField,
                chunkId: createPrimitiveField({ defaultValue: 0 }),
            },
        }),

    selectors: {
        getValues: (values) => values,
        getValueByChunkId: (values, chunkId) =>
            values.find((value) => value.chunkId === chunkId)?.intervalField || intervalField.defaultValue,
        getIndexByChunkId: (values, chunkId) => values.findIndex((value) => value.chunkId === chunkId),
    },
    actions: {
        setValues: ({ draftValue: values }, newValues: Array<{ chunkId: number; intervalField: IntervalFieldValue }>) =>
            values.map((value) => {
                const newEntry = newValues.find((entry) => entry.chunkId === value.chunkId);

                if (!newEntry) {
                    return value;
                }

                const newInterval = newEntry.intervalField;

                if (newInterval.type === 'notInterval') {
                    return {
                        ...value,
                        intervalField: newInterval,
                    };
                }

                return {
                    ...value,
                    intervalField: {
                        ...newInterval,
                        price: null,
                        currency: null,
                    },
                };
            }),
        setValueByChunkId: ({ draftValue: values }, chunkId: number, value: IntervalFieldValue) => {
            const chunk = values.find((v) => v.chunkId === chunkId);

            if (!chunk) {
                return;
            }

            if (value.type === 'notInterval') {
                chunk.intervalField = value;
            } else {
                chunk.intervalField = {
                    ...value,
                    price: null,
                    currency: null,
                };
            }
        },
        setDefaultValue: ({ draftValue: values }) => {
            values.forEach((value) => {
                value.intervalField = intervalField.defaultValue;
            });
        },
    },
});

export type ArrayIntervalFieldValue = InferFieldValue<typeof arrayIntervalField>;
